import { GET } from "./base";

export const getActivateHistory = (params) => {
  const path = "/transaction/activated";

  return GET(path, params);
};
